export default "__VITE_ASSET__t680svdU__"